export const getFileNameFromUrl = (url: string) => {
  const slashIndex = url.lastIndexOf('/');
  return url.substring(slashIndex + 1);
};
